import { captureUtmAttributionFromUrl } from '@helpers/utm-attribution.service';

captureUtmAttributionFromUrl();
